module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pheader-wrap"
  }, [_c('header', {
    staticClass: "header"
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoginRegList),
      expression: "isLoginRegList"
    }]
  }, [_c('li', {
    on: {
      "touchend": function($event) {
        _vm.goLoginOrReg(0)
      }
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('li', {
    on: {
      "touchend": function($event) {
        _vm.goLoginOrReg(1)
      }
    }
  }, [_vm._v("注册")])]), _vm._v(" "), _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isWelcome),
      expression: "isWelcome"
    }]
  }, [_c('span', [_vm._v("欢迎你")]), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.name ? _vm.name : _vm.userName)
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAlert),
      expression: "isAlert"
    }],
    staticClass: "alertMark"
  }, [_c('div', {
    staticClass: "alert-content"
  }, [_c('h4', [_vm._v(_vm._s(_vm.myFromList.title)), _c('img', {
    attrs: {
      "src": require("../assets/03.png")
    },
    on: {
      "touchend": _vm.goHome
    }
  })]), _vm._v(" "), _c('ul', [_c('li', {
    class: _vm.current == 0 ? 'active' : '',
    on: {
      "touchend": function($event) {
        _vm.goLoginOrReg(0)
      }
    }
  }, [_c('p', [_vm._v("登录")])]), _vm._v(" "), _c('li', {
    class: _vm.current == 1 ? 'active' : '',
    on: {
      "touchend": function($event) {
        _vm.goLoginOrReg(1)
      }
    }
  }, [_c('p', [_vm._v("注册")])])]), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoginContent),
      expression: "isLoginContent"
    }],
    ref: "ruleLogin",
    attrs: {
      "model": _vm.ruleLogin,
      "rules": _vm.rules,
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名",
      "prop": "userTel"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "maxlength": 11,
      "placeholder": "请输入手机号"
    },
    model: {
      value: (_vm.ruleLogin.userTel),
      callback: function($$v) {
        _vm.$set(_vm.ruleLogin, "userTel", _vm._n($$v))
      },
      expression: "ruleLogin.userTel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "密码",
      "prop": "userPwd"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "请输入密码"
    },
    model: {
      value: (_vm.ruleLogin.userPwd),
      callback: function($$v) {
        _vm.$set(_vm.ruleLogin, "userPwd", $$v)
      },
      expression: "ruleLogin.userPwd"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "forgotPassword",
    on: {
      "touchend": function($event) {
        _vm.goLoginOrReg(2)
      }
    }
  }, [_vm._v("忘记密码")]), _vm._v(" "), _c('span', {
    staticClass: "myfrom-buttons",
    on: {
      "touchend": function($event) {
        _vm.getOperation('ruleLogin')
      }
    }
  }, [_vm._v("登 录")])], 1), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isRegForm),
      expression: "isRegForm"
    }],
    ref: "registered",
    attrs: {
      "label-position": "top",
      "model": _vm.registered,
      "rules": _vm.registeredRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机号",
      "prop": "userTel"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "maxlength": 11,
      "placeholder": "请输入手机号"
    },
    on: {
      "blur": _vm.regPhone
    },
    model: {
      value: (_vm.registered.userTel),
      callback: function($$v) {
        _vm.$set(_vm.registered, "userTel", _vm._n($$v))
      },
      expression: "registered.userTel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "密码",
      "prop": "zcuserPwd"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "请输入6-16位数字或字母"
    },
    model: {
      value: (_vm.registered.zcuserPwd),
      callback: function($$v) {
        _vm.$set(_vm.registered, "zcuserPwd", $$v)
      },
      expression: "registered.zcuserPwd"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "regCodeFrom",
    attrs: {
      "label": "验证码",
      "prop": "sendSecond"
    }
  }, [_c('el-input', {
    staticClass: "regCode",
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码",
      "maxlength": 6
    },
    model: {
      value: (_vm.registered.sendSecond),
      callback: function($$v) {
        _vm.$set(_vm.registered, "sendSecond", $$v)
      },
      expression: "registered.sendSecond"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "codebutton",
    attrs: {
      "disabled": _vm.dis
    },
    on: {
      "click": _vm.getRegCode
    }
  }, [_vm._v("获取验证码"), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSecond),
      expression: "isSecond"
    }]
  }, [_vm._v(" " + _vm._s(_vm.secondText) + "s")])])], 1), _vm._v(" "), _c('span', {
    staticClass: "myfrom-buttons",
    on: {
      "touchend": function($event) {
        _vm.getRegInfo('registered')
      }
    }
  }, [_vm._v("注 册")])], 1), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isForgotPassword),
      expression: "isForgotPassword"
    }],
    ref: "setNewPassword",
    attrs: {
      "label-position": "top",
      "model": _vm.setNewPassword,
      "rules": _vm.newPas
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名",
      "prop": "userTel"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "maxlength": 11,
      "auto-complete": "off",
      "placeholder": "手机号"
    },
    on: {
      "blur": _vm.setregPhone
    },
    model: {
      value: (_vm.setNewPassword.userTel),
      callback: function($$v) {
        _vm.$set(_vm.setNewPassword, "userTel", _vm._n($$v))
      },
      expression: "setNewPassword.userTel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "regCodeFrom",
    attrs: {
      "label": "验证码",
      "prop": "sendSecond"
    }
  }, [_c('el-input', {
    staticClass: "regCode",
    attrs: {
      "type": "text",
      "placeholder": "请输入验证码",
      "maxlength": 6
    },
    model: {
      value: (_vm.setNewPassword.sendSecond),
      callback: function($$v) {
        _vm.$set(_vm.setNewPassword, "sendSecond", $$v)
      },
      expression: "setNewPassword.sendSecond"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "codebutton",
    attrs: {
      "disabled": _vm.disab
    },
    on: {
      "click": _vm.getRegNumber
    }
  }, [_vm._v("获取验证码"), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSecondT),
      expression: "isSecondT"
    }]
  }, [_vm._v(" " + _vm._s(_vm.secondTextT) + "s")])])], 1), _vm._v(" "), _c('span', {
    staticClass: "myfrom-buttons",
    on: {
      "touchend": function($event) {
        _vm.goResetPassword('setNewPassword')
      }
    }
  }, [_vm._v("下 一 步")])], 1), _vm._v(" "), _c('el-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isNewPassword),
      expression: "isNewPassword"
    }],
    ref: "ruleForm2",
    attrs: {
      "label-position": "top",
      "model": _vm.ruleForm2,
      "rules": _vm.rules2
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "请输入新密码",
      "prop": "pass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "请输入6-16位数字或字母",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.ruleForm2.pass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "pass", $$v)
      },
      expression: "ruleForm2.pass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "请确认登录密码",
      "prop": "checkPass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": "请输入6-16位数字或字母",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.ruleForm2.checkPass),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "checkPass", $$v)
      },
      expression: "ruleForm2.checkPass"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "myfrom-buttons",
    on: {
      "touchend": function($event) {
        _vm.getNewPwd('ruleForm2')
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)]), _vm._v(" "), _c('footer', {
    staticClass: "footer"
  }, [_c('ul', [_c('li', [_c('p', {
    class: _vm.ind == 0 ? 'active' : '',
    on: {
      "touchend": function($event) {
        _vm.changeIndex(0)
      }
    }
  }, [_vm._v("首页")])]), _vm._v(" "), _c('li', [_c('p', {
    class: _vm.ind == 1 ? 'active' : '',
    on: {
      "touchend": function($event) {
        _vm.changeIndex(1)
      }
    }
  }, [_vm._v("我的报告")])]), _vm._v(" "), _c('li', [_c('p', {
    on: {
      "touchend": _vm.getMoreInfo
    }
  }, [_vm._v("更多")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDropdowns),
      expression: "isDropdowns"
    }],
    staticClass: "dropdowns"
  }, [_c('ul', [_c('li', [_c('span', {
    on: {
      "click": _vm.goSetInfo
    }
  }, [_vm._v("个人设置")])]), _vm._v(" "), _c('li', [_c('span', {
    on: {
      "click": _vm.goOrdErmanagement
    }
  }, [_vm._v("订单管理")])]), _vm._v(" "), _c('li', [_c('span', {
    on: {
      "touchend": _vm.setExit
    }
  }, [_vm._v("退出系统")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/sanjiao.png")
    }
  })])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49ce3603","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/phonecomponents/pheader.vue
// module id = 754
// module chunks = 1